import http from '~/common/http'
export default {
    getIncomeList(params) {
        return http.get('/api/finance-income/index', {
            params: params
        });
    },

    getIncomeUpdate(params) {
        return http.put('/api/finance-income/update', params);
    },

    getIncomeDelete(ids) {
        return http.delete("/api/finance-income/delete", {
            params: {
                ids: ids
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/finance.js